import React, { useState } from 'react';
import { Tag, Heading, Lead, PageHero, Section, BtnPrimary } from '../components/UI';
import styles from './Contact.module.css';

const OFFICES = [
  {
    flag: '🇺🇸', country: 'United States',
    lines: [
      '800 Gathering Park Cir,',
      'unit 301 Cary Nc 27519'
    ],
    phone: '+1 682-200-6816 ',
    email: 'info@metawavesolutions.com',
  },
  {
    flag: '🇮🇳', country: 'India',
    lines: [
      'Metawave Solutions LLP',
      '2-3-54/29 & 30, Flat No.203',
      'Prameela Residency, Vijayapuri Colony',
      'Uppal, Hyderabad, Telangana – 500039',
    ],
    phone: '+91 9000371032',
    email: 'info@metawavesolutions.com',
  },
];

const SERVICES_LIST = [
  'Software Development',
  'Application Development',
  'IT Training',
  'HR Solutions',
  'Staffing Services',
  'Outsourcing / BPO',
  'Other',
];

const INITIAL = { name: '', email: '', phone: '', company: '', service: '', message: '' };

export default function Contact() {
  const [form, setForm]   = useState(INITIAL);
  const [errors, setErr]  = useState({});
  const [sent, setSent]   = useState(false);
  const [loading, setLoading] = useState(false);

  const update = key => e => setForm(f => ({ ...f, [key]: e.target.value }));

  const validate = () => {
    const e = {};
    if (!form.name.trim())    e.name    = 'Name is required';
    if (!form.email.trim())   e.email   = 'Email is required';
    else if (!/\S+@\S+\.\S+/.test(form.email)) e.email = 'Valid email required';
    if (!form.message.trim()) e.message = 'Message is required';
    return e;
  };

  const handleSubmit = e => {
    e.preventDefault();
    const errs = validate();
    if (Object.keys(errs).length) { setErr(errs); return; }
    setLoading(true);
    setTimeout(() => { setLoading(false); setSent(true); }, 1200);
  };

  if (sent) {
    return (
      <div className={styles.successWrap}>
        <div className={styles.successCard}>
          <div className={styles.successIcon}>✓</div>
          <h2 className={styles.successTitle}>Message Sent!</h2>
          <p className={styles.successSub}>
            Thank you for reaching out, <strong>{form.name}</strong>.<br />
            Our team will get back to you at <strong>{form.email}</strong> shortly.
          </p>
          <BtnPrimary onClick={() => { setSent(false); setForm(INITIAL); }} style={{ marginTop: '1.5rem' }}>
            Send Another Message
          </BtnPrimary>
        </div>
      </div>
    );
  }

  return (
    <>
      <PageHero
        tag="Contact Us"
        title="Let's Work Together"
        subtitle="Ready to start a project or need more information? Get in touch and our team will respond promptly."
      />

      <Section variant="paper">
        <div className={styles.contactGrid}>

          {/* ── Left: Info ─────────────────────────────────────── */}
          <div className={styles.infoCol}>
            <Tag>Reach Out</Tag>
            <Heading>Our Offices</Heading>
            <Lead>Whether you're in India or the United States, we're ready to assist.</Lead>

            <div className={styles.offices}>
              {OFFICES.map((office, i) => (
                <div key={i} className={styles.officeCard}>
                  <div className={styles.officeFlag}>{office.flag} {office.country}</div>
                  {office.lines.map((line, j) => (
                    <p key={j} className={styles.officeLine}>{line}</p>
                  ))}
                  {office.phone && (
                    <a href={`tel:${office.phone}`} className={styles.officeContact}>
                      📞 {office.phone}
                    </a>
                  )}
                  <a href={`mailto:${office.email}`} className={styles.officeContact}>
                    ✉️ {office.email}
                  </a>
                </div>
              ))}
            </div>

            {/* <div className={styles.quickLinks}>
              <p className={styles.quickTitle}>Quick Links</p>
              <div className={styles.quickRow}>
                {['Software Dev','App Dev','IT Training','HR & Staffing'].map((l, i) => (
                  <span key={i} className={styles.quickChip}>{l}</span>
                ))}
              </div>
            </div> */}
          </div>

          {/* ── Right: Form ────────────────────────────────────── */}
          <div className={styles.formCol}>
            <div className={styles.formCard}>
              <h3 className={styles.formTitle}>Send Us a Message</h3>
              <form onSubmit={handleSubmit} noValidate>
                <div className={styles.formRow}>
                  <div className={styles.formGroup}>
                    <label className={styles.label}>Your Name *</label>
                    <input
                      className={`${styles.input} ${errors.name ? styles.inputError : ''}`}
                      type="text"
                      placeholder="John Smith"
                      value={form.name}
                      onChange={update('name')}
                    />
                    {errors.name && <span className={styles.errMsg}>{errors.name}</span>}
                  </div>
                  <div className={styles.formGroup}>
                    <label className={styles.label}>Email Address *</label>
                    <input
                      className={`${styles.input} ${errors.email ? styles.inputError : ''}`}
                      type="email"
                      placeholder="john@company.com"
                      value={form.email}
                      onChange={update('email')}
                    />
                    {errors.email && <span className={styles.errMsg}>{errors.email}</span>}
                  </div>
                </div>

                <div className={styles.formRow}>
                  <div className={styles.formGroup}>
                    <label className={styles.label}>Phone Number</label>
                    <input
                      className={styles.input}
                      type="tel"
                      placeholder="+1 (555) 000-0000"
                      value={form.phone}
                      onChange={update('phone')}
                    />
                  </div>
                  {/* <div className={styles.formGroup}>
                    <label className={styles.label}>Company Name</label>
                    <input
                      className={styles.input}
                      type="text"
                      placeholder="Your Company"
                      value={form.company}
                      onChange={update('company')}
                    />
                  </div> */}
                </div>

                <div className={styles.formGroup}>
                  <label className={styles.label}>Subject</label>
                  <select
                    className={styles.input}
                    value={form.service}
                    onChange={update('service')}
                  >
                    <option value="">How can we help?</option>
                    {SERVICES_LIST.map(s => (
                      <option key={s} value={s}>{s}</option>
                    ))}
                  </select>
                </div>

                <div className={styles.formGroup}>
                  <label className={styles.label}>Message *</label>
                  <textarea
                    className={`${styles.input} ${styles.textarea} ${errors.message ? styles.inputError : ''}`}
                    placeholder="Tell us about your project or requirement..."
                    value={form.message}
                    onChange={update('message')}
                    rows={5}
                  />
                  {errors.message && <span className={styles.errMsg}>{errors.message}</span>}
                </div>

                <button
                  type="submit"
                  className={styles.submitBtn}
                  disabled={loading}
                >
                  {loading ? (
                    <span className={styles.loadingDots}>Sending<span>.</span><span>.</span><span>.</span></span>
                  ) : 'Send Message →'}
                </button>
              </form>
            </div>
          </div>
        </div>
      </Section>
    </>
  );
}
